import React, { useEffect, useState } from 'react'
import { Modal, Spin, Tooltip, Button, message } from 'antd'
import { getJobDetail, retryJob } from '../services/api/3dApi'
import { LoadingOutlined } from '@ant-design/icons'
import configServer from '../configs/service'
import ReactDOM from 'react-dom'

const ExportJobModal = ({ jobId, number }) => {
    const [link, setLink] = useState(null)
    const [error, setError] = useState('')
    const [errorCount, setErrorCount] = useState(0)
    const [isRetry, setIsRetry] = useState(false)
    const factoryURL = configServer.factory_url

    useEffect(() => {
        let intervalId

        const fetchDetailInfo = async () => {
            try {
                const { data: response } = await getJobDetail(jobId)
                const { success, data, message: mess } = response

                if (!success) throw new Error(mess)

                if (data.status === 'error') setIsRetry(true)

                if (data.link_download) {
                    setLink(data.link_download)
                    clearInterval(intervalId)
                } else {
                    setErrorCount(0)
                }
            } catch (error) {
                const newCount = errorCount + 1
                setErrorCount(newCount)
                if (newCount >= 5) {
                    setError(error.message)
                    clearInterval(intervalId)
                }
            }
        }

        fetchDetailInfo()
        intervalId = setInterval(fetchDetailInfo, 5000)

        return () => clearInterval(intervalId)
    }, [jobId, errorCount])

    useEffect(() => {
        if (link) {
            const a = document.createElement('a')
            a.href = link
            a.download = ''
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
            Modal.destroyAll()
        }
    }, [link])

    const retry = async (jobId) => {
        try {
            const { success, message: mess } = await retryJob(jobId)
            if (!success) {
                throw new Error(mess)
            }
            message.success(`Job đã được chạy lại.`)
        } catch (error) {
            message.error(error.message)
        }
    }

    const _handleRetry = (id) => {
        retry(id)
        setIsRetry(false)
        setErrorCount(0)
    }

    return (
        <div>
            {
                !!link ? (
                    <p>
                        File đã sẵn sàng. Bấm để tải xuống:{' '}
                        <a href={link} target="_blank" rel="noopener noreferrer" onClick={() => Modal.destroyAll()}>
                            <strong>Download Job {number}</strong>
                        </a>
                    </p>
                ) : (
                    <React.Fragment>
                        <div className='mb-2'>
                            Quá trình export đang được xử lý, vui lòng bấm vào <a
                                // href="#!"
                                id="job-exporter"
                                onClick={(e) => {
                                    e.preventDefault()
                                    window.open(`${factoryURL}/jobs/${jobId}`, '_blank')
                                    Modal.destroyAll()
                                }}
                            >
                                <strong>Job {number}</strong>
                            </a> xem file kết quả.
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            {
                                !!error ? (
                                    <span className='text-danger'>Lấy file download thất bại.</span>
                                ) : (
                                    <>
                                        <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
                                        <span>Đang xử lý lấy file download , vui lòng chờ...</span>
                                    </>
                                )
                            }
                        </div>
                        {
                            isRetry &&
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <span className="text-danger">Job error!</span>
                                <Tooltip title='Thử lại'>
                                    <Button
                                        className='btnRetry p-0 mx-2 my-1' type={'link'}
                                        style={{ height: 'unset' }}
                                        onClick={() => _handleRetry(jobId)}
                                    >
                                        <i className="fa fa-retweet" style={{ fontSize: 20 }} />
                                    </Button>
                                </Tooltip>
                            </div>
                        }
                    </React.Fragment>
                )
            }

        </div>
    )
}

export const createJobExport = (data = {}) => {
    const { _id: jobId, number } = data

    const div = document.createElement('div')
    document.body.appendChild(div)

    const destroy = () => {
        ReactDOM.unmountComponentAtNode(div)
        div.remove()
    }

    Modal.success({
        title: <span className="text-success fs-14">Tạo Job thành công</span>,
        content: <ExportJobModal jobId={jobId} number={number} />,
        okText: 'Đóng',
        onOk: destroy,
        afterClose: destroy,
    })
}